module.exports = __webpack_public_path__ + "img/p1-m.85779f52.jpg";